import ClientInvitePage from './client-invite';

export default ClientInvitePage;